// Путь: D:\QR\QR-WEB\dashboard\src\components\Admin\AdminGiftCards\AdminGiftCardOrders.jsx
// Версия: 2.0.0 - Full functionality
// Дата: 03.12.2025

import React, { useState, useEffect } from 'react';
import './AdminGiftCards.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://qr-money.onrender.com';

const STATUSES = [
  { id: 'all', label: 'Все', icon: '📋' },
  { id: 'pending', label: 'Ожидают', icon: '⏳', color: 'orange' },
  { id: 'processing', label: 'В обработке', icon: '🔄', color: 'blue' },
  { id: 'completed', label: 'Выполнены', icon: '✅', color: 'green' },
  { id: 'cancelled', label: 'Отменены', icon: '❌', color: 'red' },
];

const AdminGiftCardOrders = () => {
  const [orders, setOrders] = useState([]);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [editingOrder, setEditingOrder] = useState(null);
  const [formData, setFormData] = useState({ status: '', gift_code: '', admin_note: '' });

  const token = localStorage.getItem('authToken');

  useEffect(() => {
    fetchOrders();
    fetchStats();
  }, [filter]);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({ limit: 50 });
      if (filter !== 'all') params.append('status', filter);
      
      const res = await fetch(`${API_URL}/api/admin/giftcard-orders?${params}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setOrders(data.data || []);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/giftcard-orders/stats`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setStats(data.data || {});
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleEdit = (order) => {
    setEditingOrder(order);
    setFormData({
      status: order.status,
      gift_code: order.gift_code || '',
      admin_note: order.admin_note || ''
    });
  };

  const handleSave = async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/giftcard-orders/${editingOrder.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      const data = await res.json();
      if (data.success) {
        setEditingOrder(null);
        fetchOrders();
        fetchStats();
      } else {
        alert(data.error || 'Ошибка');
      }
    } catch (error) {
      alert('Ошибка: ' + error.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить заказ?')) return;
    try {
      const res = await fetch(`${API_URL}/api/admin/giftcard-orders/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        fetchOrders();
        fetchStats();
      }
    } catch (error) {
      alert('Ошибка: ' + error.message);
    }
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleString('ru-RU', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  };

  const getStatusInfo = (status) => STATUSES.find(s => s.id === status) || { label: status, icon: '❓' };

  if (loading && orders.length === 0) {
    return <div className="admin-loading">Загрузка...</div>;
  }

  return (
    <div className="admin-giftcards">
      <div className="admin-page-header">
        <h1 className="admin-page-title">📝 Заказы Gift Cards</h1>
      </div>

      {/* Stats */}
      <div className="gc-stats">
        <div className="gc-stat">
          <span className="gc-stat-value">{stats.total || 0}</span>
          <span className="gc-stat-label">Всего</span>
        </div>
        <div className="gc-stat" style={{borderLeft: '3px solid #f59e0b'}}>
          <span className="gc-stat-value" style={{color: '#f59e0b'}}>{stats.pending || 0}</span>
          <span className="gc-stat-label">Ожидают</span>
        </div>
        <div className="gc-stat" style={{borderLeft: '3px solid #3b82f6'}}>
          <span className="gc-stat-value" style={{color: '#3b82f6'}}>{stats.processing || 0}</span>
          <span className="gc-stat-label">В обработке</span>
        </div>
        <div className="gc-stat" style={{borderLeft: '3px solid #10b981'}}>
          <span className="gc-stat-value" style={{color: '#10b981'}}>{stats.completed || 0}</span>
          <span className="gc-stat-label">Выполнено</span>
        </div>
        <div className="gc-stat gold">
          <span className="gc-stat-value">${parseFloat(stats.total_revenue || 0).toFixed(2)}</span>
          <span className="gc-stat-label">Выручка</span>
        </div>
      </div>

      {/* Filter */}
      <div className="gc-filter">
        {STATUSES.map(s => (
          <button
            key={s.id}
            className={`gc-filter-btn ${filter === s.id ? 'active' : ''}`}
            onClick={() => setFilter(s.id)}
          >
            {s.icon} {s.label}
          </button>
        ))}
      </div>

      {/* Edit Modal */}
      {editingOrder && (
        <div className="admin-card gc-edit-modal">
          <h3>✏️ Заказ #{editingOrder.id}</h3>
          <div className="gc-edit-info">
            <p><strong>Пользователь:</strong> {editingOrder.user_email}</p>
            <p><strong>Продукт:</strong> {editingOrder.product_name}</p>
            <p><strong>Сумма:</strong> ${parseFloat(editingOrder.amount).toFixed(2)}</p>
            <p><strong>Итого:</strong> ${parseFloat(editingOrder.total_amount).toFixed(2)}</p>
          </div>
          <div className="gc-form-group">
            <label>Статус</label>
            <select
              value={formData.status}
              onChange={(e) => setFormData({...formData, status: e.target.value})}
            >
              <option value="pending">⏳ Ожидает</option>
              <option value="processing">🔄 В обработке</option>
              <option value="completed">✅ Выполнен</option>
              <option value="cancelled">❌ Отменён</option>
            </select>
          </div>
          <div className="gc-form-group">
            <label>Код карты (для выдачи клиенту)</label>
            <input
              type="text"
              value={formData.gift_code}
              onChange={(e) => setFormData({...formData, gift_code: e.target.value})}
              placeholder="XXXX-XXXX-XXXX"
            />
          </div>
          <div className="gc-form-group">
            <label>Заметка админа</label>
            <textarea
              value={formData.admin_note}
              onChange={(e) => setFormData({...formData, admin_note: e.target.value})}
              placeholder="Внутренняя заметка..."
              rows={3}
            />
          </div>
          <div className="gc-form-actions">
            <button className="admin-btn admin-btn-primary" onClick={handleSave}>💾 Сохранить</button>
            <button className="admin-btn" onClick={() => setEditingOrder(null)}>Отмена</button>
          </div>
        </div>
      )}

      {/* Orders Table */}
      <div className="admin-card">
        {orders.length === 0 ? (
          <div className="admin-empty">
            <span style={{fontSize: '48px', display: 'block', marginBottom: '15px'}}>📭</span>
            Заказов пока нет
          </div>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Пользователь</th>
                <th>Продукт</th>
                <th>Сумма</th>
                <th>Комиссия</th>
                <th>Итого</th>
                <th>Статус</th>
                <th>Дата</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {orders.map(order => {
                const statusInfo = getStatusInfo(order.status);
                return (
                  <tr key={order.id}>
                    <td>#{order.id}</td>
                    <td>{order.user_email || '-'}</td>
                    <td>{order.product_name}</td>
                    <td>${parseFloat(order.amount).toFixed(2)}</td>
                    <td>{parseFloat(order.fee_percent).toFixed(1)}%</td>
                    <td><strong>${parseFloat(order.total_amount).toFixed(2)}</strong></td>
                    <td>
                      <span className={`gc-order-status ${order.status}`}>
                        {statusInfo.icon} {statusInfo.label}
                      </span>
                    </td>
                    <td>{formatDate(order.created_at)}</td>
                    <td>
                      <button className="admin-btn admin-btn-sm" onClick={() => handleEdit(order)}>✏️</button>
                      <button className="admin-btn admin-btn-sm admin-btn-danger" onClick={() => handleDelete(order.id)}>🗑️</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminGiftCardOrders;